export const AUDIT_HISTORY_TYPES = {
  abm: {
    id: 'abm',
    label: 'label.ABM'
  },
  bizcards: {
    id: 'bizcards',
    label: 'label.BIZCARDS'
  },
  bizcardroutes: {
    id: 'bizcardroutes',
    label: 'label.BIZCARD_ROUTES'
  },
  brandkit: {
    id: 'brandkit',
    label: 'label.EMPLOYEE_BRANDING'
  },
  brandkitroutes: {
    id: 'brandkitroutes',
    label: 'label.EMPLOYEE_BRANDING_ROUTES'
  },
  ads: {
    id: 'ads',
    label: 'label.CAMPAIGNS'
  },
  csv: {
    id: 'csv',
    label: 'label.CSV'
  },
  domain: {
    id: 'domain',
    label: 'label.DOMAIN'
  },
  domainsettings: {
    id: 'domainsettings',
    label: 'label.DOMAIN_SETTINGS'
  },
  documents: {
    id: 'documents',
    label: 'label.DOCUMENTS'
  },
  images: {
    id: 'images',
    label: 'label.IMAGES'
  },
  manual: {
    id: 'manual',
    label: 'label.MANUAL'
  },
  outlookaddin: {
    id: 'outlookaddin',
    label: 'label.OUTLOOK_ADDIN'
  },
  plugins: {
    id: 'plugins',
    label: 'label.PLUGINS'
  },
  sendergroups: {
    id: 'sendergroups',
    label: 'label.GROUPS'
  },
  signatures: {
    id: 'signatures',
    label: 'label.ROUTES'
  },
  surveys: {
    id: 'surveys',
    label: 'label.SURVEYS'
  },
  tagblocks: {
    id: 'tagblocks',
    label: 'label.SIGNATURES'
  },
  user: {
    id: 'user',
    label: 'label.USER'
  }
};
